export default "__VITE_ASSET__Bg9b8Vd8__"